import { Modal } from '@/components/ui';
import type { Project } from '@/lib/types';
import { ProjectPricingSection } from './ProjectPricingSection';

/*
 * The pricing editor for one project, opened from the Prices row action on
 * /projects (owner 2026-10-27). Mount ONCE per page and hand it the row; the
 * section loads and saves its own data, and is read-only without
 * `projects.update`.
 *
 * `Modal` renders nothing while closed, so the section unmounts with it and a
 * reopen always loads the stored set afresh. The backdrop does not dismiss: a
 * clipped backdrop would throw away unsaved prices. Escape still closes.
 */
export function ProjectPricingDialog({
  project,
  onClose,
}: {
  project: Project | null;
  onClose: () => void;
}) {
  return (
    <Modal
      open={project !== null}
      onClose={onClose}
      title={project ? `Prices · ${project.name}` : 'Prices'}
      size="xl"
      dismissOnBackdrop={false}
    >
      {project && <ProjectPricingSection key={project.id} project={project} bare />}
    </Modal>
  );
}
